import { removeFalsy } from "helpers/formatter";
import {
  Company,
  ExerciseByCircuit,
  ExerciseByMuscleGroup,
  Goal,
  Group,
  HealthCondition,
  HealthConditionCategory,
  Instructors,
  Interest,
  InterestCategory,
  Physician,
} from "models/lookups";
import apiService from "modules/api/apiService";
import {
  LOOKUPS_COMPANIES,
  LOOKUPS_EXERCISES_BY_CIRCUIT,
  LOOKUPS_EXERCISES_BY_MUSCLE_GROUP,
  LOOKUPS_GOALS,
  LOOKUPS_GROUPS,
  LOOKUPS_HEALTH_CONDITIONS,
  LOOKUPS_HEALTH_CONDITIONS_CATEGORIES,
  LOOKUPS_INSTRUCTORS,
  LOOKUPS_INTERESTS,
  LOOKUPS_INTERESTS_CATEGORIES,
  LOOKUPS_MY_CURRENT_FACILITY,
  LOOKUPS_PHYSICIANS,
  LOOKUPS_RANDOM_FITLINXX_ID,
  LOOKUPS_VERIFY_FITLINXX_ID_AVAILABILITY,
} from "modules/api/endpoint";
import { TPagination } from "modules/api/type";

export const getLkpPhysiciansList = async (
  params = {}
): Promise<{
  success: boolean;
  data?: Physician[];
}> => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";

  try {
    const results = await apiService.get(
      `${LOOKUPS_PHYSICIANS}${queryParams ? `?${queryParams}` : ""}`
    );
    return { data: results.data.payload.data, success: true };
  } catch (error) {
    return { success: false };
  }
};

export const getLkpInstructorList = async (
  params = {}
): Promise<{
  success: boolean;
  data?: Instructors[];
}> => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";
  //console.log("lookupServices.ts: params is\n ", params);
  try {
    const results = await apiService.get(
      `${LOOKUPS_INSTRUCTORS}${queryParams ? `?${queryParams}` : ""}`
    );
    //console.log("lookupServices.ts: results.data is\n ", results.data.payload.data);
    return { data: results.data.payload.data, success: true };
  } catch (error) {
    return { success: false };
  }
};

export const getLkpCompanyList = async (
  params = {}
): Promise<{
  success: boolean;
  data?: Company[];
}> => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";

  try {
    const results = await apiService.get(
      `${LOOKUPS_COMPANIES}${queryParams ? `?${queryParams}` : ""}`
    );
    return { data: results.data.payload.data, success: true };
  } catch (error) {
    return { success: false };
  }
};

export const getLkpGoalsList = async (
  params = {}
): Promise<{
  success: boolean;
  data?: Goal;
}> => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";

  try {
    const results = await apiService.get(`${LOOKUPS_GOALS}${queryParams ? `?${queryParams}` : ""}`);
    return { data: results.data.payload, success: true };
  } catch (error) {
    return { success: false };
  }
};

export const getLkpInterestCategories = async (
  params = {}
): Promise<{
  success: boolean;
  data?: InterestCategory;
}> => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";

  try {
    const results = await apiService.get(
      `${LOOKUPS_INTERESTS_CATEGORIES}${queryParams ? `?${queryParams}` : ""}`
    );
    return { data: results.data.payload, success: true };
  } catch (error) {
    return { success: false };
  }
};

export const getLkpInterests = async (
  params = {}
): Promise<{
  success: boolean;
  data?: Interest[];
}> => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";

  try {
    const results = await apiService.get(
      `${LOOKUPS_INTERESTS}${queryParams ? `?${queryParams}` : ""}`
    );
    return { data: results.data.payload.data, success: true };
  } catch (error) {
    return { success: false };
  }
};

export const getLkpHealthConditionsCategories = async (
  params = {}
): Promise<{
  success: boolean;
  data?: HealthConditionCategory;
}> => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";

  try {
    const results = await apiService.get(
      `${LOOKUPS_HEALTH_CONDITIONS_CATEGORIES}${queryParams ? `?${queryParams}` : ""}`
    );
    return { data: results.data.payload, success: true };
  } catch (error) {
    return { success: false };
  }
};

export const getLkpHealthConditions = async (
  params = {}
): Promise<{
  success: boolean;
  data?: HealthCondition[];
}> => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";

  try {
    const results = await apiService.get(
      `${LOOKUPS_HEALTH_CONDITIONS}${queryParams ? `?${queryParams}` : ""}`
    );
    return { data: results.data.payload.data, success: true };
  } catch (error) {
    return { success: false };
  }
};

export const getLkpGroups = async (
  params = {}
): Promise<{
  success: boolean;
  data?: Group[];
}> => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";

  try {
    const results = await apiService.get(
      `${LOOKUPS_GROUPS}${queryParams ? `?${queryParams}` : ""}`
    );
    return { data: results.data.payload, success: true };
  } catch (error) {
    return { success: false };
  }
};

export const getLkpRandomFitlinxxId = async (
  params = {}
): Promise<{
  success: boolean;
  data?: string;
}> => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";

  try {
    const results = await apiService.get(
      `${LOOKUPS_RANDOM_FITLINXX_ID}${queryParams ? `?${queryParams}` : ""}`
    );
    return { data: results.data.payload.fitlinxx_id, success: true };
  } catch (error) {
    return { success: false };
  }
};

export const verifyFitlinxxIdAvailability = async (
  params = {}
): Promise<{
  success: boolean;
  data: boolean;
}> => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";

  try {
    const results = await apiService.post(
      `${LOOKUPS_VERIFY_FITLINXX_ID_AVAILABILITY}${queryParams ? `?${queryParams}` : ""}`,
      {}
    );

    return { data: true, success: true };
  } catch (error) {
    throw error.response.data.errors.fitlinxx_id;
  }
};

export const getCurrentFacility = async (
  params = {}
): Promise<{
  success: boolean;
  data?: {
    id: number;
    name: string;
    country: string;
    state: string;
  };
}> => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";

  try {
    const results = await apiService.get(
      `${LOOKUPS_MY_CURRENT_FACILITY}${queryParams ? `?${queryParams}` : ""}`
    );
    return { data: results.data.payload, success: true };
  } catch (error) {
    return { success: false };
  }
};

// app/Domains/FacilityTasks/Jobs/Circuits/GetExercisesListForMuscleGroupsJob.php
export const getLkpExercisesByMuscleGroup = async (
  params = {}
): Promise<{
  success: boolean;
  data?: ExerciseByMuscleGroup[];
  pagination?: TPagination;
}> => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";

  try {
    const results = await apiService.get(
      `${LOOKUPS_EXERCISES_BY_MUSCLE_GROUP}${queryParams ? `?${queryParams}` : ""}`
    );
    return { data: results.data.payload.data, success: true };
  } catch (error) {
    return { success: false };
  }
};

// app/Domains/FacilityTasks/Jobs/Circuits/GetExercisesListForCircuitsJob.php
export const getLkpExercisesByCircuit = async (
  params = {}
): Promise<{
  success: boolean;
  data?: ExerciseByCircuit[];
  pagination?: TPagination;
}> => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";

  try {
    const results = await apiService.get(
      `${LOOKUPS_EXERCISES_BY_CIRCUIT}${queryParams ? `?${queryParams}` : ""}`
    );
    return { data: results.data.payload.data, success: true };
  } catch (error) {
    return { success: false };
  }
};
